import type { QueryClient } from '@tanstack/react-query';

/**
 * Invalidira SVE keširane upite aktivnosti (detalj, lista/search, retci, sati, izvršitelji) —
 * Orval ključevi počinju s putanjom endpointa. Zove se nakon svake akcije tjednog izvještaja
 * koja zaključava/otključava aktivnosti (generiranje, dodavanje/uklanjanje aktivnosti, brisanje
 * izvještaja): bez ovoga detalj aktivnosti do isteka staleTime (5 min) prikazuje stari status
 * ("Evidentirano" umjesto "U izvještaju") i dopušta uređivanje koje backend odbija.
 */
export const invalidateActivityQueries = (queryClient: QueryClient) =>
  queryClient.invalidateQueries({
    predicate: (query) => {
      const root = query.queryKey[0];
      return typeof root === 'string' && root.startsWith('/api/v1/activities');
    }
  });
